var _rect, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 16,
    viewBox: "0 0 33 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 16,
    rx: 8,
    fill: "#1F845A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.40412 7.29608C6.37324 7.26428 6.33629 7.23901 6.29547 7.22175C6.25464 7.20449 6.21077 7.1956 6.16645 7.1956C6.12213 7.1956 6.07826 7.20449 6.03743 7.22175C5.99661 7.23901 5.95967 7.26428 5.92878 7.29608L5.46212 7.76341C5.43082 7.79431 5.40594 7.83109 5.3889 7.87163C5.37185 7.91217 5.36298 7.95568 5.3628 7.99966C5.36261 8.04364 5.37111 8.08722 5.38781 8.12791C5.40451 8.16859 5.42909 8.20558 5.46012 8.23674L7.93078 10.7081C7.99306 10.7703 8.07736 10.8054 8.16537 10.8057C8.25338 10.8061 8.33798 10.7717 8.40078 10.7101L13.5421 5.56874C13.5735 5.53783 13.5983 5.50094 13.6151 5.46026C13.6319 5.41957 13.6404 5.37592 13.64 5.33189C13.6397 5.28787 13.6305 5.24437 13.6129 5.20397C13.5954 5.16358 13.57 5.12711 13.5381 5.09674L13.0715 4.63007C13.0402 4.59875 13.0031 4.5739 12.9623 4.55694C12.9215 4.53998 12.8777 4.53125 12.8335 4.53125C12.7892 4.53125 12.7454 4.53998 12.7046 4.55694C12.6638 4.5739 12.6267 4.59875 12.5955 4.63007L8.40478 8.82074C8.34159 8.88348 8.25616 8.91868 8.16712 8.91868C8.07807 8.91868 7.99264 8.88348 7.92945 8.82074L6.40412 7.29608Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 8,
    r: 6,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle);
export default __webpack_public_path__ + "static/media/toggle.d0f9322abdda27661a11bd70511727cd.svg";
export { ForwardRef as ReactComponent };